export default "__VITE_PUBLIC_ASSET__b720ab3a__"